import { useState, useEffect, useCallback } from "react";

// Used for debug only
export const useTimer = (initialValue: number = 0) => {
  const [count, setCount] = useState<number>(initialValue);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const reset = useCallback(() => {
    setCount(initialValue);
  }, [initialValue]);

  return { count, reset };
};
